import jsxElem from "jsx-no-react";

const ModalHeader = ( { title } ) => {
    let handleClose = () => {
        document.getElementById('bmux-modal-view').innerHTML = "";
    };

    return (
        <div class="modal-header">
            <h4 class="modal-title"><strong>{title} </strong></h4>
            <button type="button" class="btn-close bmux-modal-close" onClick={handleClose}></button>
        </div>
    );
};

export {
    ModalHeader
};